import { createFileRoute } from "@tanstack/react-router";
import ProcureIntegrations from "lib/components/procure/ProcureIntegrations";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../../../components/withAuthentication";

function ProcureCostCodesPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Estimate: Cost Codes")}</title>
      </Head>
      <ProcureIntegrations path="costcodes" />
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/estimate/integrations/costcodes")({
  component: withAuthentication(ProcureCostCodesPage, { products: ["procure"] }),
});
